import React from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { useAuth } from '../../contexts/AuthContext'
import { useUserCheck } from '../../hooks/api/useUserCheck'
import { LoadingState } from '../ui/LoadingState'

interface RouteGuardProps {
  children: React.ReactNode
}

export const RouteGuard: React.FC<RouteGuardProps> = ({ children }) => {
  const { user, loading } = useAuth()
  const { data: userRecord, isLoading: userLoading } = useUserCheck(user?.id || '')
  const location = useLocation()

  // Show loading while checking user data
  if (loading || userLoading) {
    return <LoadingState />
  }

  // If no user, redirect to login
  if (!user) {
    return <Navigate to="/login" replace />
  }

  // If user record doesn't exist, redirect to subscription
  if (!userRecord) {
    return <Navigate to="/subscription" replace />
  }

  if (
    userRecord.role !== 'admin' &&
    !userRecord.company_id &&
    location.pathname !== '/subscription'
  ) {
    return <Navigate to="/subscription" replace />
  }

  // If user hasn't completed onboarding, redirect to subscription
  if (
    userRecord.role !== 'admin' &&
    !userRecord.onboarding_completed &&
    (location.pathname === '/dashboard' || location.pathname === '/')
  ) {
    return <Navigate to="/subscription" replace />
  }

  // If everything is completed, show the requested page
  return <>{children}</>
}
